import { footerCopy, footerLinks } from '@/common/copy/footer';
import { TextLink } from '@/designSystem/atoms/TextLink';

export interface SiteFooterProps {
  /** Optional utility classes on the root (e.g. `bg-canvas`). */
  className?: string;
}

/**
 * Global site footer — copyright, terms, privacy, status (Kincode marketing links).
 */
export function SiteFooter({ className = '' }: SiteFooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="agents-footer"
      className={`ds-footer ${className}`.trim()}
    >
      <div className="flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-muted" data-testid="agents-footer-trademark">
          <TextLink href={footerLinks.kincodeHome} variant="muted" data-testid="agents-footer-copyright">
            &copy; {footerCopy.copyright} {year}
          </TextLink>
        </p>

        <nav
          className="flex flex-wrap items-center gap-x-6 gap-y-2"
          aria-label="Legal and status"
          data-testid="agents-footer-links"
        >
          <TextLink href={footerLinks.termsAndConditions} variant="muted" data-testid="agents-footer-terms">
            {footerCopy.termsAndConditions}
          </TextLink>
          <TextLink href={footerLinks.privacyPolicy} variant="muted" data-testid="agents-footer-privacy">
            {footerCopy.privacyPolicy}
          </TextLink>
          <TextLink href={footerLinks.serviceStatus} variant="muted" data-testid="agents-footer-status">
            {footerCopy.serviceStatus}
          </TextLink>
        </nav>
      </div>
    </footer>
  );
}
